export { SeekSlider } from './component'
